export type PriceCalculationMode = 'inclusive' | 'exclusive'

export type PriceTarget = {
  priceCalculationMode?: PriceCalculationMode
  unitPrice: number | null
  unitPriceExcludingTaxInYen: number | null
}

export type StoragePeriodPriceTarget = {
  priceCalculationMode?: PriceCalculationMode
  bonusInYen: number | null
  bonusExcludingTaxInYen: number | null
}

export type TradingVolumeTarget = {
  priceCalculationMode?: PriceCalculationMode
  tradingVolumeInYen: number | null
  tradingVolumeExcludingTaxInYen: number | null
}

export function getDisplayUnitPrice(target: PriceTarget): number | null {
  if (target.priceCalculationMode === 'exclusive') {
    return target.unitPriceExcludingTaxInYen
  }

  return target.unitPrice
}

export function getDisplayStoragePeriodBonus(target: StoragePeriodPriceTarget): number | null {
  if (target.priceCalculationMode === 'exclusive') {
    return target.bonusExcludingTaxInYen
  }

  return target.bonusInYen
}

export function getDisplayTradingVolume(target: TradingVolumeTarget): number | null {
  if (target.priceCalculationMode === 'exclusive') {
    return target.tradingVolumeExcludingTaxInYen
  }

  return target.tradingVolumeInYen
}

export function getRequiredDisplayUnitPrice(target: PriceTarget): number {
  const unitPrice = getDisplayUnitPrice(target)
  if (unitPrice === null) {
    throw new Error('display unit price is not available for the current price calculation mode')
  }
  return unitPrice
}

export function getRequiredDisplayStoragePeriodBonus(target: StoragePeriodPriceTarget): number {
  const bonus = getDisplayStoragePeriodBonus(target)
  if (bonus === null) {
    throw new Error('display storage period bonus is not available for the current price calculation mode')
  }
  return bonus
}

export function getRequiredDisplayTradingVolume(target: TradingVolumeTarget): number {
  const tradingVolume = getDisplayTradingVolume(target)
  if (tradingVolume === null) {
    throw new Error('display trading volume is not available for the current price calculation mode')
  }
  return tradingVolume
}

export function assertExclusivePriceCalculationMode(target: { priceCalculationMode?: PriceCalculationMode }): void {
  if (target.priceCalculationMode !== 'exclusive') {
    throw new Error('price calculation mode must be exclusive')
  }
}

export function getRequiredExclusiveUnitPrice(target: PriceTarget): number {
  assertExclusivePriceCalculationMode(target)

  if (target.unitPriceExcludingTaxInYen === null || target.unitPriceExcludingTaxInYen === undefined) {
    throw new Error('exclusive unit price is not available')
  }

  return target.unitPriceExcludingTaxInYen
}

export function getRequiredExclusiveStoragePeriodBonus(target: StoragePeriodPriceTarget): number {
  assertExclusivePriceCalculationMode(target)

  if (target.bonusExcludingTaxInYen === null || target.bonusExcludingTaxInYen === undefined) {
    throw new Error('exclusive storage period bonus is not available')
  }

  return target.bonusExcludingTaxInYen
}
